// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"e4a03648","455":"031fe275","488":"5d9bf759"}[chunkId] + ".chunk.js";
};